export const FILTER_BY_NAME_PLACEHOLDER = 'Filter by Name';
export const FILTER_BY_NAME_SECTOR_SPONSOR_PLACEHOLDER = 'Filter by Sector/Industry, Name or Parent';
export const FILTER_BY_NAME_SECTOR_PLACEHOLDER = 'Filter by Sector/Industry or Name';

export const ELEMENT_SCROLL_HEIGHT = -55;
